<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BZImeq/tc-custom/9781488090370.jpg?1728851686506" alt="This image is the cover for the book Family for Easter, Rescue River"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Family for Easter, Rescue River
      </h1>
      <p class="bookDescription body article font2">
        <b>With a little help from their matchmaking kids, a single mom and a widowed landscaper find themselves building a forever family in this sweet romance.</b><br/><br/>When wealthy single mom Fiona Farmingham rents her carriage house to widowed Eduardo Delgado, it’s purely a gesture of friendship. Insecure over her late husband’s betrayal, Fiona hides her attraction to the humble landscaper. Between them they have six children, two dogs—and a world of differences. But with half a dozen little matchmakers involved, they may find the courage to reach for happiness once more . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lee Tobin McClain
      </h2>
      
      <p class="authorDescription body article">Lee Tobin McClain is the <I>New York Times</I> bestselling author of more than thirty novels. A professor-turned-writer, she finds inspiration in her beautiful and brilliant daughter, her goofy goldendoodle, and her aptly named cat, Trouble. Learn more about her books at www.leetobinmcclain.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?38ef6f3c